import * as io from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';

export const LocalizedString = io.type({
  en: io.string,
  fr: io.string,
});

export type LocalizedString = io.TypeOf<typeof LocalizedString>;
export type Locale = keyof LocalizedString;

export function isLocale(locale: string | null | undefined): locale is Locale {
  return locale ? Object.keys(LocalizedString.props).includes(locale) : false;
}

export function isLocalizedString(
  localeString: LocalizedString | string | undefined
): localeString is LocalizedString {
  if (!localeString) {
    return false;
  }
  const decoded = LocalizedString.decode(localeString);
  return isRight(decoded);
}
